import { Constants } from "../constants/constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from "../utils/utils";

@Injectable({
  providedIn: "root",
})
export class PickingService {
  constructor(private http: HttpClient, private utils: Utils) {}

  public getBuscarPedidosPicking(
    idUsuario,
    idAgencia,
    fechaInicial,
    fechaFinal,
    idUsuarioConsulta
  ): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_PICKING +
      "/" +
      idUsuario +
      "/" +
      idAgencia +
      "/" +
      fechaInicial +
      "/" +
      fechaFinal +
      "/" +
      idUsuarioConsulta;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError((err) => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Picking",
            text: "Error Cargando Pedidos Picking.",
            icon: "error",
          });
        }
        return throwError(err);
      })
    );
  }

  public getBuscarDetallesPicking(encabezados): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_PICKING + "/" + encabezados;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError((err) => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Picking",
            text: "Error Cargando Detalles Picking.",
            icon: "error",
          });
        }
        return throwError(err);
      })
    );
  }

  public getConsultarPicking(idPicking, origen): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_PICKING +
      "/" +
      idPicking +
      "/" +
      origen;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError((err) => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Picking",
            text: "Error Consultando Picking.",
            icon: "error",
          });
        }
        return throwError(err);
      })
    );
  }

  public getConsultarPickingModulo(fechaInicial, fechaFinal): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_PICKING +
      "/modulo/" +
      fechaInicial +
      "/" +
      fechaFinal;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError((err) => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Picking",
            text: "Error Consultando Picking.",
            icon: "error",
          });
        }
        return throwError(err);
      })
    );
  }

  public getConsultarPickingModuloDetalle(idPicking): Observable<any> {
    const url =
      Constants.BASE_URL + Constants.URL_PICKING + "/modulo/" + idPicking;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError((err) => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Picking",
            text: "Error Consultando Detalle Picking.",
            icon: "error",
          });
        }
        return throwError(err);
      })
    );
  }

  public postBuscarProductoPicking(params, idProducto): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_PICKING + "/" + idProducto;
    return this.http.post<any>(url, params).pipe(
      catchError((err) => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Producto Picking",
            text: "Verifique la informacion ingresada.",
            icon: "error",
            confirmButtonColor: "#127570",
          });
        }

        return throwError(err);
      })
    );
  }

  public postCrearPicking(params): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_PICKING;
    return this.http.post<any>(url, params).pipe(
      catchError((err) => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Creando Picking",
            text: "Verifique la informacion ingresada.",
            icon: "error",
            confirmButtonColor: "#127570",
          });
        }

        return throwError(err);
      })
    );
  }
}
